import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/shared/store'
import { useRedirectUrl } from '@/shared/composables/useRedirectUrl/'

const OOREDOO_LANDING_PATH = /^\/(en|ar)\/travel-ooredoo\/?$/

const isOoredooLandingUrl = (url?: string | false | null): boolean => {
  if (!url) return false

  try {
    const pathname = new URL(url).pathname.replace(/\/+/g, '/')
    return OOREDOO_LANDING_PATH.test(pathname)
  } catch {
    return false
  }
}

export const useOoredooFlow = () => {
  const { locale } = useI18n()
  const userStore = useUserStore()
  const { getRedirectUrl } = useRedirectUrl()

  const isOoredooFlow = computed(() =>
    isOoredooLandingUrl(getRedirectUrl(locale.value) ?? userStore.redirectURL)
  )

  return { isOoredooFlow }
}
